import React, { useState } from 'react';
import { Row, Modal, Button } from "react-bootstrap";
function Disclosure() {
    const [show, setShow] = useState(false);

const handleClose = () => setShow(false);
const handleShow = () => setShow(true);

    return (
        <>
        <Modal show={show} onHide={handleClose}>

<Modal.Body style={{fontWeight: 300, fontFamily: 'arial', fontSize: 12}}>
<p style={{fontSize: 14, lineHeight: '14px'}}>BankBank présente et compare une sélection de produits et n’effectue pas une comparaison sur la totalité des produits existants. Les informations et/ou documents figurant sur ce site et/ou accessibles par ce site proviennent de sources considérées comme étant fiables. Toutefois, ces informations et/ou documents sont susceptibles de contenir des inexactitudes techniques et des erreurs typographiques. L’utilisation des informations et/ou documents disponibles sur ce site se fait sous l’entière et seule responsabilité de l’utilisateur.
</p><p style={{fontSize: 14, lineHeight: '14px'}}>
Notre équipe rédige un ensemble d’articles qui a pour but d’informer les internautes. En contrepartie de cette création de contenue, le site se rémunère en diffusant des publicités présentes sur l’ensemble des pages du site. Cette diffusion peut être automatique ou basée sur des partenariats commerciaux et peut impacter la structure de nos comparatifs.
</p></Modal.Body>
<Modal.Footer>
  <Button variant="secondary" onClick={handleClose} style={{borderColor: 'rgb(229, 35, 79)', backgroundColor:'rgb(229, 35, 79)'}}>
    Fermer
  </Button>
</Modal.Footer>
</Modal>          
{/* <Row style={{maxWidth: 1230, margin: 'auto', color: 'white', fontWeight: 300, fontSize: 14, fontFamily: 'arial'}}> */}
<Row id='disclosure'>
  <div onClick={handleShow}  id='modalOpen'><span style={{textAlign: 'right', color: 'rgb(107 112 121)'}}>Annonce Légale</span></div>

  </Row>
  </>
    )
}

export default Disclosure
